import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";
import styles from "./ui.module.css";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children?: ReactNode;
  tone?: "neutral" | "success" | "warning" | "danger" | "info" | "accent";
}

export function Badge({
  children,
  className,
  tone = "neutral",
  ...rest
}: BadgeProps) {
  return (
    <span
      className={cn(
        styles.badge,
        tone === "neutral" && styles.badgeNeutral,
        tone === "success" && styles.badgeSuccess,
        tone === "warning" && styles.badgeWarning,
        tone === "danger" && styles.badgeDanger,
        tone === "info" && styles.badgeInfo,
        tone === "accent" && styles.badgeAccent,
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
